import { sanitizeRecurrence } from './recurrenceFields';
import { toHourList } from './recurrenceRule';
import {
  RECURRENCE_FREQUENCIES,
  RecurrenceFrequency,
  RecurrenceResultValues,
  RecurrenceValues,
  StoredRecurrence,
} from './types';

const toFrequency = (freq?: string): RecurrenceFrequency | undefined =>
  RECURRENCE_FREQUENCIES.find((value) => value === freq);

// picks the edited fields only: a stored rule also carries rrule/mail/file, which must not
// leak into the form and back into the payload. Sanitising here drops RFC-invalid parts a
// legacy rule may hold, so the form, the preview and the next save all agree.
export const toFormValues = (recurrence: StoredRecurrence): RecurrenceValues => {
  const hours = toHourList(recurrence?.hour);
  return sanitizeRecurrence({
    freq: toFrequency(recurrence?.freq),
    tzid: recurrence?.tzid,
    hour: hours.length ? hours[0] : 0,
    weekday: recurrence?.weekday,
    month: recurrence?.month,
    setpos: recurrence?.setpos,
    week_number: recurrence?.week_number,
    month_day: recurrence?.month_day,
    year_day: recurrence?.year_day,
  });
};

export const toResultValues = (values: RecurrenceValues): RecurrenceResultValues => {
  const sanitized = sanitizeRecurrence(values);
  const hours = toHourList(sanitized?.hour);
  return {
    ...sanitized,
    hour: hours.length ? hours : undefined,
    tzid: sanitized?.tzid || Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};
